<template>
  <div>
    <b-row class="m-0">
      <b-col class="modal-hero">
        <b-card class="p-0 m-0 shadow-none">
          <b-row>
            <b-col class="pr-0 panel-divider panel-first">
              <div class="card-panel">
                <div class="stat-box-title">Payment Plan Total</div>
                <div class="stat-box-body">
                  {{ total | currency }}
                </div>
              </div>
            </b-col>
            <b-col class="pl-0 pr-0 panel-divider">
              <div class="card-panel">
                <div class="stat-box-title">Schedule</div>
                <div class="stat-box-body">
                  {{ form.numberOfPayments }}
                  {{ (form.cycleType + "ly payments") | title }}
                </div>
              </div>
            </b-col>
            <b-col class="pl-0 pr-0 panel-divider">
              <div class="card-panel">
                <div class="stat-box-title">Date of First Payment</div>
                <div class="stat-box-body">
                  {{
                    isToday(form.startDate)
                      ? "Today"
                      : form.startDate | moment("MM/DD/YYYY")
                  }}
                </div>
              </div>
            </b-col>
            <b-col class="pl-0 pr-0 panel-divider">
              <div class="card-panel">
                <div class="stat-box-title">Processing Today</div>
                <div class="stat-box-body">
                  {{ processingToday | currency }}
                  <i class="fas fa-info-circle" id="tooltip-target-1"></i>
                  <b-tooltip target="tooltip-target-1" triggers="hover">
                    <div v-if="isDown && isFirstPayment">
                      Down + First Payment
                    </div>
                    <div v-else-if="isDown">
                      Down Payment
                    </div>
                    <div v-else-if="isFirstPayment">
                      First Payment
                    </div>
                  </b-tooltip>
                </div>
              </div>
            </b-col>

            <b-col class="pl-0 pr-0 panel-divider">
              <div class="card-panel text-right">
                <div style="float: left;">
                  <div class="stat-box-title">Card Number</div>
                  <div class="stat-box-body">
                    {{ methodSelected.description }}
                  </div>
                </div>
                <div style="float: left;" class="fixed">
                  <card-svg-large
                    height="40px"
                    :cardType="methodSelected.cardType"
                  ></card-svg-large>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row class="m-0">
      <b-col class="body-modal">
        <h5 class="h3 mb-4">Payment Schedule</h5>

        <table class="table">
          <thead>
            <tr>
              <th class="pl-0">Cycle</th>
              <th>Billing Date</th>
              <th style="text-align:right">Amount</th>
              <th class="text-right pr-0">Action</th>
            </tr>
          </thead>
          <tr
            v-for="(item, index) in paymentPlan.scheduleItems"
            v-bind:key="index"
          >
            <td
              class="pl-0"
              v-bind:class="{
                'text-success font-weight-bold': isToday(item.billingDate),
              }"
            >
              <template v-if="item.isDownPayment">
                <b>Down Payment</b>
              </template>
              <template v-else>
                {{ item.cycle }}
              </template>
            </td>
            <td>
              <div
                v-if="!item.isEdit"
                v-bind:class="{
                  'text-success font-weight-bold': isToday(item.billingDate),
                }"
              >
                {{
                  isToday(item.billingDate)
                    ? "Processing Today"
                    : item.billingDate | moment("utc", "MM/DD/YYYY")
                }}
              </div>
              <div v-else>
                <b-form-datepicker
                  v-model="item.billingDate"
                  :value-as-date="false"
                  :min="
                    index - 1 <= 0
                      ? new Date()
                      : new Date(
                          paymentPlan.scheduleItems[index - 1].billingDate
                        )
                  "
                  :max="
                    index + 1 == paymentPlan.scheduleItems.length
                      ? null
                      : new Date(
                          paymentPlan.scheduleItems[index + 1].billingDate
                        )
                  "
                ></b-form-datepicker>
              </div>
            </td>

            <td class="text-right">
              <template v-if="!item.isEdit">
                <div
                  v-bind:class="{
                    'text-success font-weight-bold': isToday(item.billingDate),
                  }"
                >
                  {{ (item.amountDue / 100) | currency }}
                </div>
              </template>
              <template v-else>
                <b-row class="row" align-h="end">
                  <b-col cols="12" style="text-align:right">
                    <div class="input-group-sm">
                      <validation-observer
                        :ref="'formValidator' + item.cycle"
                        v-slot="{ handleSubmit }"
                      >
                        <form
                          method="post"
                          @submit.prevent="handleSubmit(save(index, item))"
                        >
                          <base-input-currency
                            :inputId="'amountInput' + item.cycle"
                            setFocus="true"
                            :name="'Cycle Amount ' + item.cycle"
                            v-model="item.amountDueConverted"
                          >
                            <template #appendButton>
                              <button class="btn btn-primary" type="submit">
                                <i class="fas fa-save"></i>
                              </button>
                            </template>
                          </base-input-currency>
                        </form>
                      </validation-observer>
                    </div>
                  </b-col>
                </b-row>
              </template>
            </td>
            <td class="text-right" style="width: 100px;">
              <b-button
                dropup
                dropleft
                variant="link"
                class="text-decoration-none p-0 m-0 shadow-none"
                no-caret
                size="lg"
                v-if="!approved"
                id="dropdown-1"
                @click.prevent="edit(item)"
              >
                <i class="fa-solid fa-ellipsis"></i>
              </b-button>
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  components: {},
  props: {
    paymentPlan: null,
    customer: null,
    form: null,
    methodSelected: null,
    approved: null,
  },
  data() {
    return {
      myPaymentPlan: null,
      selectedItem: null,

      todayDate:
        new Date().getMonth() +
        1 +
        "/" +
        new Date().getDate() +
        "/" +
        new Date().getFullYear(),
    };
  },
  created() {
    this.myPaymentPlan = JSON.parse(JSON.stringify(this.paymentPlan));
    //add some calculated properties to the payment plan and emit it back
    this.emitPaymentPlan();
  },
  watch: {
    paymentPlan: function(newVal) {
      this.myPaymentPlan = newVal;
    },
  },
  computed: {
    total: function() {
      let t = 0;
      if (!this.myPaymentPlan) return 0;

      this.myPaymentPlan.scheduleItems.forEach((e) => {
        t = t + parseFloat(e.amountDue);
      });

      return t / 100;
    },
    processingToday: function() {
      let t = 0;
      if (!this.myPaymentPlan) return 0;

      this.myPaymentPlan.scheduleItems.forEach((e) => {
        console.log("------");
        console.log(e.billingDate);
        console.log(this.todayDate);
        if (this.isSameDay(e.billingDate, this.todayDate))
          t = t + parseFloat(e.amountDue);
      });
      return t / 100;
    },
    isDown: function() {
      return (
        this.isSameDay(
          this.myPaymentPlan.scheduleItems[0].billingDate,
          this.todayDate
        ) && this.myPaymentPlan.scheduleItems[0].isDownPayment
      );
    },

    isFirstPayment: function() {
      if (this.myPaymentPlan.scheduleItems[0].isDownPayment)
        return this.isSameDay(
          this.myPaymentPlan.scheduleItems[1].billingDate,
          this.todayDate
        );
      else
        return this.isSameDay(
          this.myPaymentPlan.scheduleItems[0].billingDate,
          this.todayDate
        );
    },
    processingTodayCount: function() {
      let t = 0;
      if (!this.myPaymentPlan) return 0;

      this.myPaymentPlan.scheduleItems.forEach((e) => {
        if (
          new Date(e.billingDate).getTime() ==
          new Date(this.todayDate).getTime()
        )
          t = t++;
      });
      return t;
    },
  },

  methods: {
    isSameDay(d1, d2) {
      var d11 = new Date(d1);
      var d22 = new Date(d2);
      return (
        d11.getFullYear() === d22.getFullYear() &&
        d11.getMonth() === d22.getMonth() &&
        d11.getDate() === d22.getDate()
      );
    },
    isToday(date) {
      return this.isSameDay(date, this.todayDate);
    },
    save(index, item) {
      item.amountDue = (item.amountDueConverted * 100).toFixed(0);
      item.billingDate = this.$moment(item.billingDate).format("MM/D/YYYY");

      item.isEdit = false;

      //this.myPaymentPlan.scheduleItems[index] = item;
      Vue.set(this.myPaymentPlan.scheduleItems, index, item);

      this.emitPaymentPlan();
    },
    emitPaymentPlan() {
      this.myPaymentPlan.isDown = this.isDown;
      this.myPaymentPlan.isFirstPayment = this.isFirstPayment;
      this.myPaymentPlan.processingToday = this.processingToday;

      this.$emit("paymentPlanUpdated", this.myPaymentPlan);
    },
    edit(item) {
      if (item.isEdit) {
        item.isEdit = false;
        return;
      }

      item.billingDate = new Date(item.billingDate);

      this.myPaymentPlan.scheduleItems.forEach((e) => {
        e.isEdit = false;
      });

      item.isEdit = !item.isEdit;

      Vue.nextTick(() => {
        document.getElementById("amountInput" + item.cycle).focus();
        document.getElementById("amountInput" + item.cycle).select();
      });
    },
  },
};
</script>

<style scoped>
.stat-box-body {
  padding-top: 1px;
}

.fixed {
  width: 80px;
}

.fa-info-circle {
  color: #adb5bd;
  font-size: 0.8em;
  padding-left: 3px;
  top: -1px;
  position: relative;
}
</style>
